import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../app/hooks"
import { CompanyData } from "../../../../../models/company-data";
import { dialogAction } from "../../../../../slices/dialog-slice";
import { Button } from "../../../../ui/button/button"
import { Input } from "../../../../ui/input/input";
import { Label } from "../../../../ui/label/label";
import './delete-company-edit-dialog.scss';
import { apiIsp, ApiManager } from "../../../../../managers/api-manager";
import { IspLogOperation } from "../../../../../models/logs/isp-log-operation";

type Props = {
  companyData: CompanyData,
}
export const DeleteCompanyEditDialog = (props: Props) => {
  const {
    companyData,
  } = props;
  const dispatch = useAppDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const [immediately, setImmediately] = useState(false);
  
  const onSubmit = useCallback(() => {
    IspLogOperation('openDeleteCompanyDialogUpdate');
    if (!companyData.delete_reservation_id && !isDelete) {
      dispatch(dialogAction.pop());
      return;
    };
    const req = {
      company_code: companyData.company_code,
      is_immediate: immediately ? 1 : 0,
    }
    if (!companyData.delete_reservation_id)  {
      
      apiIsp.deleteCompany().post(req).then((res) => {
        if (String((res as any).header.status_code) !== '200') {
          return;
        }
        dispatch(dialogAction.pushMessage({
          title: '完了',
          message: [
            'データ削除の登録が完了しました。',
          ],
          buttons: [
            { label: 'OK', callback: () => dispatch(dialogAction.popAll()) },
          ]
        }))
      }).catch((e) => ApiManager.onError(e));
    } else {
      apiIsp.deleteCompany()
      .edit({
        id: companyData.delete_reservation_id,
        is_delete: isDelete ? 1 : 0,
        is_immediate: req.is_immediate,
      }).then((res) => {
        if (String((res as any).header.status_code) !== '200') {
          return;
        }
        dispatch(dialogAction.pushMessage({
          title: '完了',
          message: [
            'データ削除の登録が完了しました。',
          ],
          buttons: [
            { label: 'OK', callback: () => dispatch(dialogAction.popAll()) },
          ]
        }))
      }).catch((e) => ApiManager.onError(e));

    }
  }, [
    dispatch,
    companyData,
    isDelete,
    immediately,
  ]);

  useEffect(() => {
    if (companyData.delete_reservation_id) {
      apiIsp.deleteCompany().getDetail(companyData.delete_reservation_id).then((res) => {
        if (res.header.status_code !== 200) return;
        setIsDelete(true);
        setImmediately(!!res.body.data.immediate_at);
      }).catch((e) => ApiManager.onError(e));
    }
  }, []);

  return (
    <>
      <div className="delete-company-edit-dialog__body">
        <div className="edit_wrap">
          <h3>■企業情報</h3>
            <div className="edit_box">
              <div className="item_wrap">
                <div className="item_head">
                  企業コード
                </div>
                <div className="item_cnt">
                  <Label str={companyData.company_code} />
                </div>
              </div>
              <div className="item_wrap">
                <div className="item_head">
                  企業名
                </div>
                <div className="item_cnt">
                  <Label str={companyData.name} />
                </div>
              </div>
              <div className="item_wrap">
                <div className="item_head">
                  電話番号
                </div>
                <div className="item_cnt">
                  <Label str={companyData.tel} />
                </div>
              </div>
              <div className="item_wrap">
                <div className="item_head">
                  利用停止日
                </div>
                <div className="item_cnt">
                  <Label str={companyData.scheduled_to_stop_at.replaceAll('-', '/').slice(0, 10)} />
                </div>
              </div>
            </div>
        </div>
        <div className="edit_wrap">
          <h3>■データ削除</h3>
            <div className="edit_box">
              <div className="item_wrap">
                <div className="item_head">
                  データ削除
                </div>
                <div className="item_cnt">
                  <div className="radio_style">
                    <Input
                      id="delete_true"
                      type="radio"
                      name="delete"
                      checked={isDelete}
                      onClick={() => setIsDelete(true)}
                    />
                    <label htmlFor="delete_true">する</label>
                  </div>
                  <div className="radio_style">
                    <Input
                      id="delete_false"
                      type="radio"
                      name="delete"
                      checked={!isDelete}
                      onClick={() => {
                        setIsDelete(false);
                        setImmediately(false);
                      }}
                    />
                    <label htmlFor="delete_false">しない</label>
                  </div>                  
                </div>
              </div>
              <div className="item_wrap">
                <div className="item_head">
                  即時削除
                </div>
                <div className="item_cnt">
                  <div className={`radio_style ${!isDelete ? 'disabled' : ''}`}>
                    <Input
                      id="immediately_true"
                      type="radio"
                      name="immediately"
                      checked={immediately}
                      disabled={!isDelete}
                      onClick={() => {
                        if (!isDelete) return;
                        setImmediately(true);
                      }}
                    />
                    <label htmlFor="immediately_true">する</label>
                  </div>
                  <div className={`radio_style ${!isDelete ? 'disabled' : ''}`}>
                    <Input
                      id="immediately_false"
                      type="radio"
                      name="immediately"
                      checked={!immediately}
                      disabled={!isDelete}
                      onClick={() => {
                        if (!isDelete) return;
                        setImmediately(false);
                      }}
                    />
                    <label htmlFor="immediately_false">しない</label>
                  </div>                  

                </div>
              </div>
            </div>
        </div>
      </div>
      <footer className="">
        <Button color="tertiary" label="キャンセル" onClick={() => {
          IspLogOperation('openDeleteCompanyDialogCancel');
          dispatch(dialogAction.pop())
          }}
        />
        <Button color="primary" label="更新" onClick={() => onSubmit()} />
      </footer>    
    </>
  )
}